export default __webpack_public_path__ + "static/media/Group 733.9d4e04b2.jpg";